export default "__VITE_ASSET__DHPLKT15__"